import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IListCollectionsRequest } from './list-collections-request';
import type { IListCollectionsResponse } from './list-collections-response';
import { listCollectionsResponseSchema } from './list-collections-response';

export async function listCollectionsApi(
  params?: IListCollectionsRequest,
): Promise<IValidatedResponse<IListCollectionsResponse>> {
  const queryParams: Record<string, string | number> = {};
  if (params?.parentId !== undefined) {
    queryParams.parentId = params.parentId ?? 'null';
  }
  if (params?.type) {
    queryParams.type = params.type;
  }
  if (params?.status) {
    queryParams.status = params.status;
  }
  if (params?.cursor) {
    queryParams.cursor = params.cursor;
  }

  return getRequest<IListCollectionsResponse>({
    path: '/sys/collections',
    schema: listCollectionsResponseSchema,
    options: { params: Object.keys(queryParams).length > 0 ? queryParams : undefined },
  });
}
